export const DIMINISHING_FIXED_EQUAL_AMORTIZATION =
  "DIMINISHING_FIXED_EQUAL_AMORTIZATION";
export const STRAIGHT_LINE_AMORTIZATION = "STRAIGHT_LINE_AMORTIZATION";
export const USER_ADMIN = "Administrator";
export const USER_STAFF = "Staff";
export const USER_OWNER = "Owner";
export const USER_SUPERVISOR = "Supervisor";
export const MSALVIO = "msalvio";
export const LOAN_APPROVED = "A";
export const LOAN_DISAPPROVED = "D";
export const SOCKET_ENDPOINT = "http://:5035";
export const PAYMENT_OPTION_CASH = "Cash";
export const PAYMENT_OPTION_CREDIT_CARD = "Credit Card";
export const SENIOR_DISC_5_PERCENT = "5% DISCOUNT";
export const SENIOR_DISC_VAT_EXEMPTED_AND_20_PERCENT =
  "VAT EXEMPTED AND 20% DISCOUNT";
export const SENIOR_DISC_RATIO = "VAT EXEMPTED AND 20% DISC RATIO";
export const SENIOR_DISC_NA = "N/A";
export const OPENING_TIME = "opening_time";
export const CLOSING_TIME = "closing_time";
export const CREDIT = "Credit";
export const DEBIT = "Debit";
export const APPROVED = "Approved";
export const DISAPPROVED = "Disapproved";
export const PENDING = "Pending";
export const DONE = "Done";
export const FINALIZED = "Finalized";

export const STATUS_ACCOMPLISHED = "Accomplished";
export const STATUS_CLOSED = "Closed";
export const STATUS_ALLOW_PRICE_EDIT = "Allow Price Edit";
export const STATUS_ALLOW_EDIT = "Allow Edit";

export const PO_STATUS_ACCOMPLISHED = "Accomplished";
export const PO_STATUS_PENDING = "Pending";
export const PO_STATUS_PARTIAL = "Partial";
export const PO_STATUS_CLOSED = "Closed";
export const STATUS_PAID = "Paid";
export const STATUS_FULFILLED = "Fulfilled";

export const PAYMENT_TYPE_CHECK = "Check";
export const PAYMENT_TYPE_TELEGRAPHIC_TRANSFER = "Telegraphic Transfer";

export const CHECK_STATUS_CLEARED = "Cleared";
export const CHECK_STATUS_BOUNCED = "Bounced";

export const USER_INVENTORY = "Inventory";
export const USER_ADMINISTRATOR = "Administrator";
export const USER_DISPATCHER = "Dispatcher";
export const USER_BODEGA = "Bodega";
export const OPEN = "Open";
export const CANCELLED = "Cancelled";

export const BUNDLED = "Bundled";
export const UNBUNDLED = "Unbundled";

export const SETTING_MAIN_WAREHOUSE = "main_warehouse";
export const SETTING_STORE = "store";

export const PRICING_OPTION_WHOLESALE = "Wholesale";
export const PRICING_OPTION_OOT = "OOT";
export const PRICING_OPTION_STORE = "Store";
export const NATURE_OF_WORK_TYPE_INDIVIDUAL = "Individual";
export const NATURE_OF_WORK_TYPE_GROUP = "Group";
export const DELIVERY_TYPE_DELIVERED_BY_SUPPLIER = "CO-DEL";

export const SOURCE_SUPPLIER = "Depot";
export const SOURCE_DEPOT = "Tank Farm";
export const SOURCE_SUPPLIER_DEPOT = "Depot/Tank Farm";
export const SOURCE_SUPPLIER_WITHDRAWALS = "Supplier Withdrawals";
export const SOURCE_TANKER_SCHEDULING = "Tanker Scheduling";

export const DELIVERY_TYPE_COMPANY_DELIVERED = "Company Delivered";
export const DELIVERY_TYPE_PICKUP = "Pickup";
export const DELIVERY_TYPE_PICKUP_DEPOT = "Pickup-Depot";
export const DELIVERY_TYPE_PICKUP_TANK_FARM = "Pickup-Tank Farm";
export const DELIVERY_TYPE_PICKUP_OWN_DELIVERY = "Own Delivery";
export const DELIVERY_TYPE_PICKUP_OWN_PICKUP = "Own Pickup";
export const DELIVERY_TYPE_PICKUP_BODEGA = "Pickup-Bodega";
export const DELIVERY_TYPE_PICKUP_VESSEL = "Pickup-Vessel";
export const DELIVERY_TYPE_PICKUP_BY_CUSTOMER = "Pickup by Customer";
export const TERMS_COD = "COD";
export const TERMS_M30 = "M30";
export const TERMS_30_DAYS = "30 DAYS";
export const TERMS_15_DAYS = "15 DAYS";

export const STATUS_PARTIAL = "Partial";
export const STATUS_FULL = "Full";

export const ACCESS_AUDIT = "Audit";
export const ACCESS_VIEW = "View";
export const ACCESS_OPEN = "Open";
export const ACCESS_APPROVE = "Approve";
export const ACCESS_CANCEL = "Cancel";
export const ACCESS_DELETE = "Delete";
export const ACCESS_PRINT = "Print";
export const ACCESS_ADD = "Add";
export const ACCESS_UPDATE = "Update";
export const ACCESS_ADVANCE_SEARCH = "Advance Search";
export const ACCESS_PRICE_CHANGE = "Price Change";
export const PRINT = "Print";

export const PAYROLL_REGULAR = "Regular";
export const PAYROLL_OVERTIME = "Overtime";
export const PAYROLL_SPECIAL = "Special";
export const PAYROLL_SPECIAL_HOLIDAY = "Special Holiday";
export const PAYROLL_REGULAR_HOLIDAY = "Regular Holiday";
export const PAYROLL_SUMMARY = "Summary";
export const PAYROLL_DEDUCTIONS = "Deductions";
export const PAYROLL_FINANCIAL_ASSISTANCE = "Financial Assistance";

export const ACCOUNT_TYPE_CONSIGNEE = "Consignee";
export const ACCOUNT_TYPE_CUSTOMER = "Customer";
export const CUSTOMER_PRICING_RETAIL = "Retail";
export const CUSTOMER_PRICING_DEALER = "Dealer";
export const PAYMENT_TYPE_CASH = "Cash";
export const PAYMENT_TYPE_CHARGE = "Charge";

export const ORIENTATION_HORIZONTAL = "Horizontal";
export const ORIENTATION_VERTICAL = "Vertical";

export const FOR_APPROVAL = "For Approval";
export const APPROVED_FOR_QUOTE = "Approved for Quote";
export const CLOSED = "Closed";

export const PURCHASE_ORDER_GENERATED = "Purchase Order Generated";
export const COMPARATIVE_CLOSED = "Comparative Closed";
export const CLOSE_QUOTE = "Close Quote";

export const VAT_TYPE_PERCENT = "PERCENT";
export const VAT_TYPE_VALUE = "VALUE";

export const SETTING_ACCOUNTS_PAYABLE = "ap_trade";
export const SETTING_UNUSED_SUPPLIES = "unused_supplies";
export const SETTING_OUTPUT_VAT = "output_vat";
export const SETTING_INPUT_VAT = "input_vat";

export const PERMISSION_PROJECTED_DISPLAY =
  "/permissions/display-projected-value";

export const FOR_CREDIT_MEMO = "FOR CREDIT MEMO";

export const MENU_ITEM = "Menu Items";
export const DISCOUNT_TYPE_VALUE = "VALUE";
export const DISCOUNT_TYPE_RATE = "RATE";
export const STATUS_FOR_VALIDATION = "For Validation";
